import { createContext, useContext } from 'react';

export const PanelContext = createContext();

export const PanelProvider = PanelContext.Provider;

export function usePanel() {
  const panel = useContext(PanelContext);
  if (panel === null) {
    throw new Error('panel cannot be null, please add the context provider for Panel');
  }
  return panel;
}
